import React, { useEffect } from "react";
import { useSearchParams, useNavigate, Navigate } from "react-router-dom";
import {
  QueryParamKeys, useAppDispatch, PublicRoutes, Message, AccountErrorMessages, useAppSelector, DefaultRoutes, QueryParamValues, CreateAccountSteps, normalizeQueryUserId,
  account_types, useAuthContext
} from "src/common";
import { Loading } from "src/components";
import { uiActions, accountActions } from "src/store";

function ClaimAccountComponent() {
  const [search_params] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const current_account = useAppSelector((state) => state.account.current_account);
  const step = useAppSelector((state) => state.account.status);
  const { loginComplete } = useAuthContext();

  // Description: load accounts and current account from crypto (First onload event)
  useEffect(() => {
    handleClaimAccount();
  }, []);

  // Description: Update the login status when current account is set in state
  useEffect(() => {
    (!!current_account) &&
      loginComplete(current_account, account_types.full,
        `${DefaultRoutes.mail_default}?${QueryParamKeys.PAGE_ACTION_QUERY_KEY}=${QueryParamValues.new}`);
  }, [current_account]);

  // Description: Initialize and process claim account from data in query string
  function handleClaimAccount() {
    const user_id = normalizeQueryUserId(search_params.get(QueryParamKeys.USER_ID_QUERY_KEY));
    const secret = search_params.get(QueryParamKeys.SECRET_QUERY_KEY)?.trim();
    const key_version = search_params.get(QueryParamKeys.KEY_VERSION_KEY)?.trim();
    const account_type = search_params.get(QueryParamKeys.ACCOUNT_TYPE_KEY)?.trim();
    if (!!user_id && !!secret && key_version) {
      if (account_type && account_type === account_types.express) {
        const params = new URLSearchParams({
          [QueryParamKeys.USER_ID_QUERY_KEY]: user_id,
          [QueryParamKeys.SECRET_QUERY_KEY]: secret,
          [QueryParamKeys.KEY_VERSION_KEY]: key_version,
          [QueryParamKeys.ACCOUNT_TYPE_KEY]: account_types.express
        });
        navigate(`/${PublicRoutes.create_account_route}?${params.toString()}`);
      } else {
        dispatch(accountActions.setNewLocalAccount({ user_id, secret, key_version: Number(key_version) }));
      }
    } else {
      dispatch(uiActions.handleRequestErrors(new Message(AccountErrorMessages.claim_account_missing_params),
        {
          stack_message: "The link to claim account is missing data",
          stack_error: { user_id, secret, key_version }
        }));
      navigate(`/${PublicRoutes.get_started_route}`);
    }
  }

  return step === CreateAccountSteps.SUBMIT_ERROR ?
    <Navigate to={`/${PublicRoutes.get_started_route}`} /> :
    step === CreateAccountSteps.CERTIFICATE_NOT_FOUND ?
      <Navigate to={`/${PublicRoutes.certificate_not_found_route}`} /> :
      <Loading />
    ;
}

export default React.memo(ClaimAccountComponent);
